export const colors = {
    black: "#000000",
    eastBay: "#4a5069",
    mischkaOpacity: "rgba(182, 183, 185, 0.2)",
    white: "#ffffff",
    silver: "#bbbbbb",
    blueChill: "#438892"
}
